import { useEffect, useState } from 'react';
import { api } from '../../api.ts';
import { formatDateRange, formatEuros, MISSION_STATUS_LABELS } from '../../format.ts';

interface AdminMission {
  id: string;
  title: string;
  status: string;
  starts_at: string;
  ends_at: string;
  organization_name: string;
  city: string;
  payment_status: string | null;
  amount_cents: number | null;
  extra_first_name: string | null;
  extra_last_name: string | null;
}

const PAYMENT_LABELS: Record<string, string> = {
  PENDING: 'En attente',
  AUTHORIZED: 'Autorisé',
  CAPTURED: 'Encaissé',
  FAILED: 'Échec',
  REFUNDED: 'Remboursé',
  CANCELLED: 'Annulé',
};

export function AdminMissions() {
  const [missions, setMissions] = useState<AdminMission[] | null>(null);
  const [status, setStatus] = useState('');

  useEffect(() => {
    const params = status ? `?status=${status}` : '';
    api.get<{ missions: AdminMission[] }>(`/admin/missions${params}`).then((res) => setMissions(res.missions));
  }, [status]);

  return (
    <div>
      <div style={{ marginBottom: 14 }}>
        <select className="input" style={{ maxWidth: 240 }} value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">Tous les statuts</option>
          {Object.entries(MISSION_STATUS_LABELS).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      </div>

      {!missions && <div className="empty-state">Chargement…</div>}
      {missions && missions.length === 0 && <div className="empty-state">Aucune mission.</div>}
      {missions && missions.length > 0 && (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr><th>Mission</th><th>Établissement</th><th>Extra</th><th>Créneau</th><th>Statut</th><th>Paiement</th><th>Montant</th></tr>
            </thead>
            <tbody>
              {missions.map((m) => (
                <tr key={m.id}>
                  <td style={{ fontWeight: 700 }}>{m.title}</td>
                  <td>{m.organization_name} · {m.city}</td>
                  <td>{m.extra_first_name ? `${m.extra_first_name} ${m.extra_last_name}` : '—'}</td>
                  <td>{formatDateRange(m.starts_at, m.ends_at)}</td>
                  <td><span className="badge badge-neutral">{MISSION_STATUS_LABELS[m.status] ?? m.status}</span></td>
                  <td>{m.payment_status ? PAYMENT_LABELS[m.payment_status] ?? m.payment_status : '—'}</td>
                  <td>{m.amount_cents !== null ? formatEuros(m.amount_cents) : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
